var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSmiley = function SvgIconSmiley(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m-1.875 8.125a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m5.25 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-6.41 2.123a1 1 0 1 0-1.73 1.004 5.51 5.51 0 0 0 9.53 0 1 1 0 0 0-1.73-1.004 3.51 3.51 0 0 1-6.07 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconSmiley;